<template>
  <div>
    <div v-if="this.isAuthenticated">
      <div class="d-flex flex-column align-items-center justify-content-center">
        <div class="masthead text-center py-md-5 py-0">
          <div class="mt-2 container flex-column justify-content-center align-items-center d-flex">
          </div>
        </div>
        <div class="container d-md-block d-none mt-5">
            <div class="card-deck">
              <router-link class="card card-link py-4 shadow" to="/myroutinetasks" v-if="userPermissions.reportEvents && !isBlueRidgeOrMadisonCommunities">
                <div class="card-body text-center">
                  <i class="fas fa-2x fa-tasks text-secondary"></i>
                  <h5 class="card-title mt-4 mb-1 text-body">My Tasks</h5>
                  <p class="card-text text-muted">Execute My Tasks</p>
                </div>
              </router-link>
              <router-link class="card card-link py-4 shadow" to="/EventAdd" v-if="userPermissions.reportEvents">
                <div class="card-body text-center">
                  <i class="fas fa-2x fa-plus text-success"></i>
                  <h5 class="card-title mt-4 mb-1 text-body">Add Event</h5>
                  <p class="card-text text-muted">Quickly report a new event.</p>
                </div>
              </router-link>
              <router-link class="card card-link py-4 shadow" :to="{path:'/Events', query: {statusType:null}}" v-if="userPermissions.manageEvents">
                <div class="card-body text-center">
                  <i class="fas fa-2x fa-calendar-check"></i>
                  <h5 class="card-title mt-4 mb-1 text-body">Event Status</h5>
                  <p class="card-text text-muted">View the status of existing events.</p>
                </div>
              </router-link>
              <router-link class="card card-link py-4 shadow" to="/properties" v-if="userPermissions.manageProperties">
                <div class="card-body text-center">
                  <i class="fas fa-2x fa-building text-danger"></i>
                  <h5 class="card-title mt-4 mb-1 text-body">Manage Properties</h5>
                  <p class="card-text text-muted">Manage your properties and on call personnel</p>
                </div>
              </router-link>
            </div>
        </div>
        <div class="container d-md-none d-flex flex-column justify-content-between p-0" style="height: calc(100vh - 100px);">
          <div class="text-center d-flex flex-column align-items-center justify-content-center flex-grow-1">
            <div class="mobile-icon d-flex justify-content-center align-items-center pt-3">
              <img class="mb-4" height="80px" src="../assets/images/icon_rg-new.png">
            </div>
          </div>
          <div class="d-flex flex-column px-4 pb-4">
            <div>
              <router-link class="btn btn-lg btn-outline-light shadow p-4 w-100 mb-3 rounded-pill" to="/Events" v-if="userPermissions.manageEvents">
                  <i class="fa fa-calendar-check-o"></i>
                  <span class="card-title mt-3">Manage Events</span>
              </router-link>
            </div>
            <div v-if="!isBlueRidgeOrMadisonCommunities">
              <router-link class="btn btn-lg btn-outline-light shadow p-4 w-100 mb-3 rounded-pill" to="/MyRoutineTasks" v-if="userPermissions.reportEvents">
                <span class="fa fa-list-alt"></span>
                <span>Manage My Tasks</span>
              </router-link>
            </div>
            <div>
              <router-link class="btn btn-lg btn-success shadow p-4 w-100 rounded-pill" to="/EventAdd" v-if="userPermissions.reportEvents">
                <span class="fa fa-plus"></span>
                <span>Add New Event</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <dashboard class="mb-md-5 mb-5" ref="dashboard" />
    </div>

    <!--Modal-->
    <b-modal v-model="showMissingCompanies" size="l" title="Unrecognized User Name" centered no-close-on-backdrop no-close-on-esc hide-header-close hide-footer>
       <template #modal-header="">
      <h2><i class="fas fa-exclamation-triangle" aria-hidden="true"></i> Unrecognized User Name</h2>
    </template>
        <div>
          The user name <strong>{{userName}}</strong> is not associated to a ResponseGrid account.  For assistance, please contact your account administrator.<br/><br/><br/>
          <a href="#" @click.prevent="logout"  title="logout" ><b-button variant="danger">CLICK HERE TO LOGIN AGAIN WITH A DIFFERENT USER NAME</b-button></a>
        </div>
    </b-modal>
  </div>
</template>
<script>
import { spr2Procedures } from '../mixins/Spr2SharedFunctions'
import Dashboard from '../views/Dashboard.vue'

export default {
  mixins: [spr2Procedures],
  components: {
    dashboard: Dashboard
  },
  data () {
    return {
    //  showMissingCompanies: false
    }
  },
  created () {
    if (this.spr2_isAuthenticated) {
      console.log('has companies ' + this.userCompanies.length)
      //   this.showMissingCompanies = this.userCompanies.length === 0
    }
  },

  computed: {
    isBlueRidgeOrMadisonCommunities () {
      if (this.$store.state.userCurrentCompany != null) {
        return (this.$store.state.userCurrentCompany.companyName === 'Blue Ridge Companies' || this.$store.state.userCurrentCompany.companyName === 'Madison Communities')
      } else {
        return false
      }
    },
    userName: {
      get: function () {
        return this.$store.state.spr2Profile.userProfile.email
      }
    },
    userPermissions () {
      return this.$store.state.loggedInUserPermissions
    },
    showMissingCompanies () {
      return this.$store.state.spr2Profile.companies.length === 0
    },
    userCompanies () {
      return this.$store.state.spr2Profile.companies
    }
  },
  methods: {
    logout () {
      this.$auth.logout({
        returnTo: window.location.origin
      })
    }
  }
}
</script>
<style scoped>
.masthead h1 {
  margin-bottom: 0;
  margin-top: 0;
  font-weight: normal;
  font-size: 250%;
}
@media screen and (max-width: 767px) {
  .masthead {
      height: 100%;
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      z-index: -1;
      background-color: #13385a;
      background: linear-gradient(145deg, #0b2b48 20%,#091927 100%);
  }

  .masthead:before {
    background-image: none;
  }

  .card-transparent {
    background: rgba(255, 255, 255, 0.25);
  }

  .card-transparent:hover {
    background: rgba(255, 255, 255, 0.4);
    text-decoration: none;
  }
  .mobile-icon {
    width: 200px;
    height: 200px;
    border-radius: 50%;
    border: 3px solid rgba(255, 255, 255, 0.1);
    background: rgba(255, 255, 255, 0.025);
    box-shadow: 4px 0px 32px rgba(0, 0, 0, 0.25);
  }
}
</style>
